import React from 'react';
import './Audience.css';
import Marquee from 'react-double-marquee';

const Audience = (props) => {
    return (
        <section className="audience">
            <div className='audience_wrap container--full' style={{
                width: '100%',
                whiteSpace: 'nowrap',
            }}>
                <div className="audience_head container">
                    <h2 className="audience_title colorful">Who should attend</h2>
                </div>
                <div className="audience_content">
                    <Marquee direction='left' speed={0.03} delay={0} childMargin={0}>
                        <span className="white">Key Discussions of the Summit</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Signals Under the Hood</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Leading Insights of the Summit</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">The Stages Of An Angular Architecture With Nx</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Key Discussions of the Summit</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Meta Framework in Action with AnalogJs</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Leading Insights of the Summit</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Unleashing the Power of Template-Driven Forms with Signals</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Key Discussions of the Summit</span>
                        <span className="white">&#x2022;</span>
                        <span className="white">Full throttle with Angular, NgRx & Stores</span>
                        <span className="white">&#x2022;</span>
                    </Marquee>
                    <Marquee direction='left' speed={0.02} delay={0} childMargin={0}>
                        <span className="orange">Latest features of Angular 18</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">Ivy Renderer</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">In-Depth Look: Angular 18's Newest Capabilities</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">Reduced footprint</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">Latest features of Angular 18</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">TypeScript 3.x </span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">In-Depth Look: Angular 18's Newest Capabilities</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">JIT and AOT (Ahead-of-Time)</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">Latest features of Angular 18</span>
                        <span className="orange">&#x2022;</span>
                        <span className="orange">Expanded debugging capabilities</span>
                        <span className="orange">&#x2022;</span>
                    </Marquee>
                </div>
            </div>
        </section >
    );
};

export default Audience;